import React, { FunctionComponent, useContext } from "react";

import { GridContainer, Row, Column, BoundedContent } from "@vp/swan";
import { RatingReviewData, ReviewDisplay } from "@vp/rating-reviews-component";

import { AnalyticsContext } from "../../contexts/AnalyticsContextProvider";
import { ContentfulPageProductPageV2 } from "../../types/ContentfulTypes";
import PageConfig from "../../utils/PageConfig";

import "../../styles/Reviews.scss";
import { analyticsPageData } from "../../utils/analyticsConfig";

export interface ReviewsProps {
  pageData: ContentfulPageProductPageV2;
  reviews: RatingReviewData;
  locale: string;
}

const showReviews = (reviews: RatingReviewData, hideReviews: boolean, locale: string) => {
  return reviews?.summary?.reviewsCount > 0 && !hideReviews;
};

export const Reviews: FunctionComponent<ReviewsProps> = (props: ReviewsProps) => {
  const { pageData, locale, reviews } = props;
  const { analyticsPageName } = useContext(AnalyticsContext);
  if (!showReviews(reviews, !!pageData.hideReviews, locale)) {
    return null;
  }

  const reviewData: RatingReviewData = {
    ...reviews,
    isDevelopment: PageConfig.isDevelopment,
  };

  return (
    <BoundedContent className="reviews-outer-container" id="reviews-container">
      <GridContainer>
        <Row>
          <Column span={12} className="reviews-tab-content">
            <ReviewDisplay
              {...reviewData}
              trackingData={{
                productId: pageData?.mpv?.mpvId,
                coreProductId: pageData?.mpv?.coreProductId,
                category: analyticsPageData.category,
                pageSection: analyticsPageData.pageSection,
                pageStage: analyticsPageData.pageStage,
                pageName: analyticsPageName(pageData?.mpv?.mpvId),
              }}
            />
          </Column>
        </Row>
      </GridContainer>
    </BoundedContent>
  );
};

export default Reviews;
